<template src="./template.html"></template>

<script setup>
import { useStore } from "vuex"
import { computed, onMounted, ref, watch } from "vue"
import { paymentManager } from "@/composables/usePayment"

defineProps({
  isButtonHidden: {
    type: Boolean,
    default: false,
  },
})

const store = useStore()
const isRendered = ref(false)
const amazonPayContainer = ref(null)

onMounted(() => {
  loadAmazonSDK()

  watch(
    () => store.state.payment.amazonPayConfig,
    (config) => {
      if (config && window.amazon?.Pay) {
        initAmazonPayExpressButton()
      }
    },
    { immediate: true }
  )
})

function loadAmazonSDK() {
  const script = document.createElement('script')
  script.src = 'https://static-eu.payments-amazon.com/checkout.js'
  document.head.append(script)
  script.onload = _ => initAmazonPayExpressButton()
}

async function initAmazonPayExpressButton() {
  if (isRendered.value) return

  const config = store.state.payment.amazonPayConfig
  if (!config) return

  isRendered.value = true

  await window.amazon.Pay.renderButton(
    "#vue-amazon-pay-button",
    JSON.parse(JSON.stringify(store.state.payment.amazonPayConfig))
  )

  injectCustomStyles()

  paymentManager.register({
    init: () => amazonPayContainer.value?.click()
  })
}

function injectCustomStyles() {
  const host = document.querySelector('#vue-amazon-pay-button')

  if (host && host.shadowRoot) {
    const style = document.createElement('style')
    style.textContent = `
      .amazonpay-button-container-rows {
        grid-template-rows: 29px 8px 6.3px;
      }
      .amazonpay-button-view1 {
        border: none !important;
        background: #f0c14b !important;
        outline: none !important;
        box-shadow: none !important;
      }
      .amazonpay-button-sandbox-logo,
      .amazonpay-button-chevrons {
        display: none;
      }
      picture.amazonpay-button-logo {
        height: 16px;
        grid-row: unset !important;
        margin-top: 8px;
      }
    `
    host.shadowRoot.appendChild(style)
  } else {
    setTimeout(injectCustomStyles, 100)
  }
}
</script>
